module.exports = __webpack_public_path__ + "img/p-vouchers.c76eb03d.svg";